var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"pa-0 index-col",attrs:{"cols":"auto"}},[_c('v-img',{staticClass:"index-img",attrs:{"src":require("@/assets/Home/Header.png")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }